<template>
  <div class="crumb">
    <img src="./images/back.png" alt="" @click="back" class="back" />
    <span class="prev-level">{{ prevLevel }}/</span>
    <span class="title">{{ current }}</span>
  </div>
</template>

<script>
export default {
  props: {
    prevLevel: {
      type: String,
      default: ''
    },
    current: {
      type: String,
      default: ''
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="stylus" scoped>
.crumb
  color #000
  line-height 60px
  height 60px
  display flex
  align-items center
  border-bottom 1px solid rgba(206,219,239,0.5)
  .back
    cursor pointer
  .prev-level
    font-size 12px
    color #999999
    margin-left 10px
  .title
    font-size 16px
    margin-left 2px
</style>
